const DEFAULT_SCOPE_SETTINGS = {
  hide: [],
};

const DEFAULT_MENU_CUSTOMIZATION = {
  enabled: false,
  cssClass: '',
  skipForUnrestrictedUser: true,
  hideSections: [],
  scopes: {
    sidebar: DEFAULT_SCOPE_SETTINGS,
    profile: DEFAULT_SCOPE_SETTINGS,
  },
};

const normalizeKey = value => String(value || '').trim().toLowerCase();

const toArray = values => {
  if (values === undefined || values === null) {
    return [];
  }

  return Array.isArray(values) ? values : [values];
};

const normalizeList = values => {
  return toArray(values)
    .map(value => String(value ?? '').trim())
    .filter(Boolean);
};

const normalizeScopeSettings = values => {
  return {
    hide: normalizeList(values?.hide),
  };
};

const getRawMenuCustomizationSettings = () => {
  return globalThis?.chatwootConfig?.forkFeatureFlags?.menuCustomization || {};
};

const normalizeMenuCustomizationSettings = settings => {
  return {
    enabled: settings?.enabled === true,
    cssClass: String(settings?.cssClass || '').trim(),
    skipForUnrestrictedUser: settings?.skipForUnrestrictedUser !== false,
    hideSections: normalizeList(settings?.hideSections),
    scopes: {
      sidebar: normalizeScopeSettings(settings?.scopes?.sidebar),
      profile: normalizeScopeSettings(settings?.scopes?.profile),
    },
  };
};

const getItemKeys = item => {
  return [item?.restrictionKey, item?.name]
    .map(value => String(value || '').trim())
    .filter(Boolean);
};

const applyCustomizationRecursively = (items, settings) => {
  const hiddenKeys = new Set(settings.hide.map(value => normalizeKey(value)));

  return items
    .map(item => {
      const shouldHide = getItemKeys(item)
        .map(value => normalizeKey(value))
        .some(value => hiddenKeys.has(value));

      if (shouldHide) {
        return null;
      }

      const children = Array.isArray(item.children)
        ? applyCustomizationRecursively(item.children, settings)
        : item.children;

      return {
        ...item,
        ...(children ? { children } : {}),
      };
    })
    .filter(Boolean);
};

export const getMenuCustomizationConfig = (scope = 'sidebar') => {
  const rawSettings = getRawMenuCustomizationSettings();
  const normalizedSettings = {
    ...DEFAULT_MENU_CUSTOMIZATION,
    ...normalizeMenuCustomizationSettings(rawSettings),
  };

  const isUnrestrictedUser =
    globalThis?.chatwootConfig?.forkFeatureFlags?.isUnrestrictedUser === true;

  const scopeSettings =
    normalizedSettings.scopes[scope] || DEFAULT_SCOPE_SETTINGS;

  return {
    enabled:
      normalizedSettings.enabled &&
      !(normalizedSettings.skipForUnrestrictedUser && isUnrestrictedUser),
    cssClass: normalizedSettings.cssClass,
    hide: scopeSettings.hide,
    hideSections: normalizedSettings.hideSections,
  };
};

export const applyMenuCustomization = (items, menuCustomizationConfig) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const settings = menuCustomizationConfig || getMenuCustomizationConfig();

  if (!settings.enabled) {
    return items;
  }

  return applyCustomizationRecursively(items, settings);
};
